import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import RestaurantsPriorityTable from '../../../components/tables/RestaurantsPriorityTable';
import { getRestaurants } from '../../../reducers';
import { setRestaurants } from '../../../actions/setRestaurants';
import LoadingPage from '../../../components/LoadingPage';
import { setActivePropToRestaurant } from '../../../actions/SetActivePropToRestaurant';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Select, Button } from 'antd';
import { db } from '../../../config/Fire';
import * as Constants from '../../../constants/nodes_database';
import cloneDeep from 'lodash.clonedeep';
import './styles.css';

const { Option } = Select

function comparePriority( a, b, restaurantsIds ) {
    if(restaurantsIds) {
        var positionA = restaurantsIds.indexOf(a.id)
        var positionB = restaurantsIds.indexOf(b.id)
        if(a.enabled && !b.enabled) {
            return -1
        } else {
            if(!a.enabled && b.enabled) {
                return 1
            } else {
                if(positionA !== -1 && positionB !== -1) {
                    if (positionA < positionB) {
                        return -1
                    } else {
                        return 1
                    }
                } else {
                    if(positionA !== -1) {
                        return -1
                    } else {
                        if(positionB !== -1) {
                            return 1
                        } else {
                            if ( a.name > b.name ) {
                                return 1;
                            }
                            if ( a.name < b.name ) {
                                return -1;
                            }
                                return 0;
                        }
                    }
                }
            }
        }
    } else {
        if ( a.name > b.name ) {
            return 1;
        }
        if ( a.name < b.name ) {
            return -1;
        }
            return 0;
    }
};

function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
};

class RestaurantsPriorityAdmin extends Component {
    state = {
        data: null,
        priorityArrayToSave: null,
        fullAddressSelected: null,
        isSavingPriority: false,
        priorityCityIsSaved: true,
        categories: null,
        fullAddressArray: null,
    }

    handleRestaurants() {
        const { restaurants, setRestaurants } = this.props;
        if(!restaurants) {
            setRestaurants();
            return <LoadingPage className="LoadingPageCont"/>;
        }
    }

    handleCities = () => {
        db.ref(`${Constants.CATEGORIES2}`).once("value")
        .then((categoriesSnap) => {
            if(categoriesSnap.exists()) {
                var categories = categoriesSnap.val()
                const { restaurants } = this.props;
                var fullAddressArray = []
                Object.keys(restaurants).forEach(key => {
                    if(restaurants[key].address && restaurants[key].address.fullAddress && restaurants[key].address.fullAddress !== "//" && fullAddressArray.indexOf(restaurants[key].address.fullAddress) === -1) {
                        fullAddressArray.push(restaurants[key].address.fullAddress)
                    } else {
                        if(restaurants[key].nearCities) {
                            Object.keys(restaurants[key].nearCities).forEach(nearCity => {
                                var fullAddressSlash = nearCity.replace(/_/g, '/');
                                if(fullAddressArray.indexOf(fullAddressSlash) === -1) {
                                    fullAddressArray.push(fullAddressSlash)
                                }
                            });
                        }
                    }
                });
                this.setState(function(previousState, currentProps) {
                    if(fullAddressArray.length > 0) {
                        return { fullAddressArray: fullAddressArray, categories: categories };
                    }
                });
            }
        })
    }

    savePriorities = () => {
        const { categories, priorityArrayToSave, fullAddressSelected } = this.state;
        var fullAddressUnderscore = fullAddressSelected.replace(/\//g, '_');
        this.setState(function(prevState, props) {
            return { isSavingPriority: true }
        })
        if(categories[fullAddressUnderscore] !== undefined && categories[fullAddressUnderscore].priority !== undefined) {
            var priority = cloneDeep(categories[fullAddressUnderscore].priority)
            priority.restaurantsIds = priorityArrayToSave
            return db.ref(`${Constants.CATEGORIES2}/${fullAddressUnderscore}`).update({ priority })
            .then(() => {
                this.setState(function(prevState, props) {
                    var categories = prevState.categories
                    categories[fullAddressUnderscore].priority.restaurantsIds = priorityArrayToSave
                    return { isSavingPriority: false, priorityCityIsSaved: true, categories }
                })
            })
        } else {
            return db.ref(`${Constants.CATEGORIES2}/${fullAddressUnderscore}/priority`).update({ name: "Recomendados", restaurantsIds: priorityArrayToSave })
            .then(() => {
                this.setState(function(prevState, props) {
                    var categories = prevState.categories
                    if(categories[fullAddressUnderscore] === undefined) {
                        categories[fullAddressUnderscore] = { "priority": { "name": "Recomendados", "restaurantsIds": priorityArrayToSave } }
                    } else {
                        if(categories[fullAddressUnderscore].priority === undefined) {
                            categories[fullAddressUnderscore].priority = { "name": "Recomendados", "restaurantsIds": priorityArrayToSave }
                        }
                    }
                    return { isSavingPriority: false, priorityCityIsSaved: true, categories }
                })
            })
        }
    }

    onCitySelected = (fullAddress) => {
        const { restaurants } = this.props;
        const { categories } = this.state;
        if(restaurants) {
            var fullAddressUnderscore = fullAddress.replace(/\//g, '_');
            const data = [];
            var restaurantsFromCityData = [];
            var restaurantsNearCityData = [];
            for (var key in restaurants) {
                if(restaurants[key] && restaurants[key].address && restaurants[key].address.fullAddress && fullAddress === restaurants[key].address.fullAddress) {
                    restaurantsFromCityData.push(restaurants[key]);
                } else {
                    if(restaurants[key] && restaurants[key].nearCities && restaurants[key].nearCities[fullAddressUnderscore] !== undefined) {
                        restaurantsNearCityData.push(restaurants[key]);
                    }
                }
            }
            restaurantsFromCityData.forEach(restaurant => {
                data.push({
                    id: restaurant.id,
                    name: restaurant.name, 
                    active: restaurant.active,
                    email: restaurant.email,
                    inCity: true,
                    enabled: (categories[fullAddressUnderscore] !== undefined && categories[fullAddressUnderscore].priority !== undefined && categories[fullAddressUnderscore].priority.restaurantsIds !== undefined && categories[fullAddressUnderscore].priority.restaurantsIds.indexOf(restaurant.id) !== -1)
                });
            });
            restaurantsNearCityData.forEach(restaurant => {
                data.push({
                    id: restaurant.id,
                    name: restaurant.name,
                    city: restaurant.address.city,
                    active: restaurant.active,
                    email: restaurant.email,
                    inCity: false,
                    enabled: (categories[fullAddressUnderscore] !== undefined && categories[fullAddressUnderscore].priority !== undefined && categories[fullAddressUnderscore].priority.restaurantsIds !== undefined && categories[fullAddressUnderscore].priority.restaurantsIds.indexOf(restaurant.id) !== -1)
                });
            });
            var priorityArrayToSave = (categories[fullAddressUnderscore] !== undefined && categories[fullAddressUnderscore].priority !== undefined && categories[fullAddressUnderscore].priority.restaurantsIds !== undefined) ? categories[fullAddressUnderscore].priority.restaurantsIds : undefined
            data.sort((a, b) => comparePriority(a, b, priorityArrayToSave));
            var priorityCityIsSaved = true
            this.setState(function(prevState, props) {
                return { data, priorityArrayToSave, priorityCityIsSaved, fullAddressSelected: fullAddress }
            })
        }
    }

    resetPriorities = () => {
        const { categories, data, fullAddressSelected } = this.state;
        var fullAddressUnderscore = fullAddressSelected.replace(/\//g, '_');
        var newPriorityArrayToSave = (categories[fullAddressUnderscore] !== undefined && categories[fullAddressUnderscore].priority !== undefined && categories[fullAddressUnderscore].priority.restaurantsIds !== undefined) ? categories[fullAddressUnderscore].priority.restaurantsIds : undefined
        data.forEach(resto => { 
            resto.enabled = (newPriorityArrayToSave && newPriorityArrayToSave.indexOf(resto.id) !== -1)
        });
        data.sort((a, b) => comparePriority(a, b, newPriorityArrayToSave));
        var priorityCityIsSaved = true
        this.setState(function(prevState, props) {
            return { data, priorityArrayToSave: newPriorityArrayToSave, priorityCityIsSaved }
        })
    }

    changePosition = (direction, id) => {
        const { categories, priorityArrayToSave, data, fullAddressSelected } = this.state;
        var newPriorityArrayToSave = cloneDeep(priorityArrayToSave)
        switch (direction) {
            case "UP":
                newPriorityArrayToSave = array_move(newPriorityArrayToSave, newPriorityArrayToSave.indexOf(id), newPriorityArrayToSave.indexOf(id) - 1)
                break;
            case "DOWN":
                newPriorityArrayToSave = array_move(newPriorityArrayToSave, newPriorityArrayToSave.indexOf(id), newPriorityArrayToSave.indexOf(id) + 1)
                break;
            default:
                break;
        }
        data.sort((a, b) => comparePriority(a, b, newPriorityArrayToSave));
        var fullAddressUnderscore = fullAddressSelected.replace(/\//g, '_');
        var priorityArraySaved = (categories[fullAddressUnderscore] !== undefined && categories[fullAddressUnderscore].priority !== undefined && categories[fullAddressUnderscore].priority.restaurantsIds !== undefined) ? categories[fullAddressUnderscore].priority.restaurantsIds : []
        var priorityCityIsSaved = (JSON.stringify(priorityArraySaved) === JSON.stringify(newPriorityArrayToSave))
        this.setState(function(prevState, props) {
            return { data, priorityArrayToSave: newPriorityArrayToSave, priorityCityIsSaved }
        })
    }

    changeEnabledState = (checked, id) => {
        const { categories, priorityArrayToSave, data, fullAddressSelected } = this.state;
        var newPriorityArrayToSave = cloneDeep(priorityArrayToSave)
        data.forEach(restaurant => {
            if(restaurant.id === id) {
                restaurant.enabled = checked
            }
        });
        if(checked) {
            if(newPriorityArrayToSave === undefined) {
                newPriorityArrayToSave = []
            }
            newPriorityArrayToSave.push(id)
        } else {
            var index = newPriorityArrayToSave.indexOf(id)
            if(index !== -1) {
                newPriorityArrayToSave.splice(index, 1);
            }
        }
        data.sort((a, b) => comparePriority(a, b, newPriorityArrayToSave));
        var fullAddressUnderscore = fullAddressSelected.replace(/\//g, '_');
        var priorityArraySaved = (categories[fullAddressUnderscore] !== undefined && categories[fullAddressUnderscore].priority !== undefined && categories[fullAddressUnderscore].priority.restaurantsIds !== undefined) ? categories[fullAddressUnderscore].priority.restaurantsIds : []
        var priorityCityIsSaved = JSON.stringify(priorityArraySaved) === JSON.stringify(newPriorityArrayToSave)
        this.setState(function(prevState, props) {
            return { data, priorityArrayToSave: newPriorityArrayToSave, priorityCityIsSaved }
        })
    }

    render() {
        const { restaurants } = this.props;
        const { fullAddressArray, isSavingPriority, priorityCityIsSaved, priorityArrayToSave, data } = this.state;
        return (
            <div>
                {
                    restaurants ?
                        fullAddressArray ?
                            <Grid style={{ width: "100%" }}>
                                <Row center="xs">
                                    <Col xs={8}>
                                        <Select className="selectCityCont" placeholder="Seleccione una ciudad" onSelect={this.onCitySelected} >
                                            { fullAddressArray && fullAddressArray.map(fullAddress => {
                                                var fullAddressSplited = fullAddress.split("/")
                                                return <Option key={fullAddress} value={fullAddress}>{fullAddressSplited[2]}</Option>
                                            }) }
                                        </Select>
                                    </Col>
                                    <Col xs={2}>
                                        {
                                            isSavingPriority ?
                                                <Button type="primary" disabled loading>
                                                    Guardando
                                                </Button>
                                                :
                                                priorityCityIsSaved ?
                                                    <Button type="primary" disabled>
                                                        Guardar
                                                    </Button>
                                                    :
                                                    <Button type="primary" onClick={this.savePriorities}>
                                                        Guardar
                                                    </Button>
                                        }
                                    </Col>
                                    <Col xs={2}>
                                        {
                                            isSavingPriority ?
                                                <Button disabled loading>
                                                    Guardando
                                                </Button>
                                                :
                                                priorityCityIsSaved ?
                                                    <Button disabled>
                                                        Reiniciar
                                                    </Button>
                                                    :
                                                    <Button onClick={this.resetPriorities}>
                                                        Reiniciar
                                                    </Button>
                                        }
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col xs={12}>
                                        <RestaurantsPriorityTable data={data} priorityArrayToSave={priorityArrayToSave} onMove={this.changePosition} onChangeEnabledState={this.changeEnabledState} />
                                    </Col>
                                </Row>
                            </Grid>
                            :
                            <div>
                                {this.handleCities()}
                                <LoadingPage className="LoadingPageCont" />
                            </div>
                        :
                        this.handleRestaurants()
                }
            </div>
        );
    }
}

RestaurantsPriorityAdmin.propTypes = {
    restaurants: PropTypes.object,
    setActivePropToRestaurant: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setRestaurants: value => dispatch(setRestaurants(value)),
    setActivePropToRestaurant: value => dispatch(setActivePropToRestaurant(value)),
});

const mapStateToProps = state => ({ 
    restaurants: getRestaurants(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(RestaurantsPriorityAdmin));